export default "__VITE_ASSET__CICwKnZS__"